import React from 'react';
import CompanyProfileWidgetBuilder from './CompanyProfileWidgetBuilder';
import CompanyProfileWidgetRenderer from './CompanyProfileWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { CompanyProfileWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';

export { default as CompanyProfileWidgetBuilder } from './CompanyProfileWidgetBuilder';
export { default as CompanyProfileWidgetRenderer } from './CompanyProfileWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'company_profile',
  meta: {
    label: 'Company Profile',
    icon: React.createElement(FontAwesomeIcon, { icon: faBuilding }),
    description: 'Company reference data — name, sector, industry, market cap, and P/E',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'COMPANY_PROFILE',
    params: [],
  },
  defaultSize: { w: 6, h: 4, minW: 4, minH: 3 },
  defaultConfig: () => ({} as CompanyProfileWidgetConfig),
  Builder: CompanyProfileWidgetBuilder,
  Renderer: CompanyProfileWidgetRenderer,
  Preview,
};
